import styled from "@emotion/styled"
import PropTypes from "prop-types"

const HeroScrollContainerEffectWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-bottom: 38px;
  padding-top: 40px;
  background: linear-gradient(to bottom, #00000000, #000000);
`

const HeroScrollContainerContent = styled.div`
  z-index: 1;
  bottom: 38px;

  ${({ theme }) => theme.breakpoints.up("3xl")} {
    margin-left: 150px;
  }

  ${({ theme }) => theme.breakpoints.down("3xl")} {
    margin-left: 120px;
  }

  ${({ theme }) => theme.breakpoints.down("2xl")} {
    margin-left: 96px;
  }

  ${({ theme }) => theme.breakpoints.down("xl")} {
    margin-left: 10%;
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    margin-left: 48px;
    margin-right: 48px;
    margin-bottom: 164px;
  }

  ${({ theme }) => theme.breakpoints.down("sm")} {
    margin-left: 16px;
    margin-right: 16px;
  }
`

const HeroScrollContainer = ({ children }) => {
  return (
    <HeroScrollContainerEffectWrapper>
      <HeroScrollContainerContent>{children}</HeroScrollContainerContent>
    </HeroScrollContainerEffectWrapper>
  )
}

HeroScrollContainer.propTypes = {
  children: PropTypes.node.isRequired,
}

export default HeroScrollContainer
